var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSimpleArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 16,
    viewBox: "0 0 10 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.02348 15.6933C8.23875 15.8918 8.51272 16 8.83561 16C9.48141 16 10 15.531 10 14.9357C10 14.6381 9.86301 14.3675 9.63796 14.1601L2.78865 7.99098L9.63796 1.83991C9.86301 1.63247 10 1.35288 10 1.06426C10 0.468997 9.48141 8.28891e-07 8.83562 7.72434e-07C8.51272 7.44206e-07 8.23875 0.108231 8.02348 0.306652L0.410958 7.16122C0.136986 7.39572 0.00978406 7.68433 -6.99382e-07 8C-7.26979e-07 8.31567 0.136986 8.58625 0.410958 8.82976L8.02348 15.6933Z",
    fill: "#07285D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimpleArrowLeft);
export default __webpack_public_path__ + "static/media/SimpleArrowLeft.83824a9eb091c12e298783be0d96097e.svg";
export { ForwardRef as ReactComponent };